function setDefaultValues(object, defaultValues)
{
    angular.forEach(defaultValues, function (value, key) {

        if (object[key] != undefined) return true;

        object[key] = value;
    });

    return object;
}